import React, { useEffect, useState } from 'react';

const ThemeContext = React.createContext(null);

interface IThemeContext {
  theme_mode: string; //'light',
  sub_header: {
    bg_color: string;
    bg_color_selected: string;
    font_color_selected: string;
    font_color: string;
    bg_image: string;
  };
  theme_color: string;
  footer: { bg_color: string; navigation: []; bg_image: string };
  theme_image: string;
  header: {
    bg_color: string;
    font_color: string;
    bg_image: string;
  };
  body: { bg_color: null; bg_image: null; font_color: string; border_color_selected: string; border_color: string };
}

export const ThemeProvider = props => {
  const [theme, setTheme] = useState<IThemeContext>(props.initialProps || {});
  return <ThemeContext.Provider value={{ theme, setTheme }}>{props.children}</ThemeContext.Provider>;
};

type UseThemeType = {
  theme: IThemeContext;
  setTheme: (theme: IThemeContext) => void;
};
export default function useTheme(): UseThemeType {
  return React.useContext(ThemeContext);
}
